// apps/web/src/lib/compras/uuid.ts — Fase 13 (WR-C06). UUID só em forma de texto: serve para descartar parâmetro de URL
// malformado antes de enviá-lo à API (que responderia 400 e derrubaria a tela). Quem decide se o id existe é o servidor.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function ehUuid(valor: string | null | undefined): valor is string {
  return typeof valor === 'string' && UUID.test(valor);
}
